// import { Notifications } from "@orbital/games-frontend-library"
import { Notifications } from "@orbital/games-frontend-library"
import { roundReset } from "./roundUserUpdate"

let alreadyWasHere = false
let placeBetOnNextRound = false

export function autoNextStep(
  e: any,
  autoCurrent: any,
  stake: any,
  finalBalance: any,
  autoConfigs: any,
  astroSocketMessages: any,
  handleNotification: any,
  stopAuto: any,
  setusers: any,
  betOnExplosion: any,
  handleBetOnExplosion: any,
  notification: any,
  setbetSend: any,
  betError: any,
) {
  if(!autoCurrent.isAutoOn) placeBetOnNextRound = false
  if (e.state === 1 && e.starttimer === 1) {
    alreadyWasHere = false
    if (
      (betError !== 0 || notification === Notifications.invalidBet) &&
      // (placedBet.error.code === 112 || placedBet.error.code === 108) &&
      autoCurrent.isAutoOn
    ) {
      placeBetOnNextRound = false
      stopAuto()
      return
    }
    if (placeBetOnNextRound) {
      placeBetOnNextRound = false
      autoCurrent.betsRemained !== "" && autoCurrent.betsRemained--
      astroSocketMessages.placeBet(
        stake,
        autoConfigs.cashoutAt,
        true,
        setbetSend,
      )
    }
  }
  if (alreadyWasHere) return
  if (
    e.state === 2 &&
    (betError === 112 ||
      betError === 108 ||
      betError === 106 ||
      notification === Notifications.invalidBet)
  ) {
    placeBetOnNextRound = false
    stopAuto()
    return
  }
  if (
    e.state === 2 &&
    (betError === 115 || notification === Notifications.maxbetlimit)
  ) {
    placeBetOnNextRound = false
    stopAuto()
    return
  }
  if (betOnExplosion) {
    handleBetOnExplosion(false)
    placeBetOnNextRound = true
    return
  }
  if (e.state === 3) {
    alreadyWasHere = true
    if (autoCurrent.isAutoOn) {
      if (autoCurrent.betsRemained === 0) {
        stopAuto()
      }
      if (autoCurrent.betsRemained > 0 || autoCurrent.betsRemained === "") {
        placeBetOnNextRound = true
      }
    }
    setusers((users: any) => roundReset(users))
  }

  // setround(e)
}
